export default __webpack_public_path__ + "static/media/033-test tube.4141aaa0.svg";